import api from '@/services/api'
import { dateNowUsOneYearAgo } from '@/utils/date'

export default {
  state: {
    moviments: {
      data: [],
      filters: {
        onlyActive: true,
        startDate: dateNowUsOneYearAgo(),
        searchDataTable: '',
      },
    },
  },

  mutations: {
    SET_MOVIMENTS(state, moviments) {
      state.moviments = moviments
    },
  },

  actions: {
    // Listagem de movimentos
    async getMoviments({ commit }, filters) {
      try {
        const response = await api.get(
          `/documents/moviments?startDate=${filters.startDate}&onlyActive=${filters.onlyActive}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    // Detalhes do movimento
    async getMoviment({ commit }, idMov) {
      try {
        const response = await api.get(`/documents/moviments/${idMov}`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    // Itens do movimento
    async getMovimentItens({ commit }, idMov) {
      try {
        const response = await api.get(`/documents/moviments/${idMov}/itens`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    // Salva uma medição do movimento
    async saveMovimentMeasure({ commit }, data) {
      try {
        return await api.post(
          `/documents/moviments/${data.get('idMov')}/measures`,
          data,
        )
      } catch (error) {
        throw error
      }
    },

    // Lista medições do movimentto
    async getMovimentMeasures({ commit }, idMov) {
      try {
        const response = await api.get(`/documents/moviments/${idMov}/measures`)

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    // Atualiza medição do movimento
    async updateMovimentMeasure({ commit }, data) {
      try {
        return await api.put(
          `/documents/moviments/${data.idmov}/measures/${data.measureId}`,
          data,
        )
      } catch (error) {
        throw error
      }
    },

    setMoviments({ commit }, data) {
      commit('SET_MOVIMENTS', data)
    },

    resetMoviments({ commit }) {
      const moviments = {
        data: [],
        filters: {
          onlyActive: true,
          startDate: dateNowUsOneYearAgo(),
          searchDataTable: '',
        },
      }
      commit('SET_MOVIMENTS', moviments)
    },
  },

  getters: {
    moviments: (state) => state.moviments,
  },
}
